exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".copy-stage-card p {\n  margin: 0;\n}\n", ""]);

